import { Error, createError, ErrorCodes } from '@quickplay/foundation';
import { PlayerErrorCodes } from '../../PlayerErrorCodes';
import { PlayerErrorResponse, PlayerStreamingErrorResponse } from './CommandResponses';

const createPlayerError = (
  errorCode: number,
  errorMessage?: string,
  contextDescription?: string,
  internalError?: Error,
): Error => {
  return createError(
    errorCode | ErrorCodes.ERROR_CATEGORY_MASK_PLAYBACK,
    errorMessage || 'Unknown player error occurred.',
    internalError,
    contextDescription,
  );
};

export const convertToPlayerError = (errorMessage: PlayerErrorResponse): Error => {
  if (errorMessage.error === 'drm_error') {
    return createPlayerError(
      PlayerErrorCodes.DRM_LICENSE_FAILURE,
      `Error due to DRM licence failure.`,
      errorMessage.error_info,
    );
  } else {
    return createPlayerError(
      PlayerErrorCodes.MEDIA_PLAYBACK_FAILURE,
      `Media Playback has failed.`,
      errorMessage.error_info,
    );
  }
};

export const convertToPlayerStreamingError = (errorMessage: PlayerStreamingErrorResponse): Error => {
  return createPlayerError(
    PlayerErrorCodes.MEDIA_SOURCE_FAILURE | ErrorCodes.ERROR_CATEGORY_MASK_NETWORK,
    'HTTP network request failed with an error, but not from the server.',
    errorMessage.status_code,
  );
};
